import React from 'react';
import DesktopBanner from '../../../assets/desktop-banner.svg';

const Banner: React.FC = () => (
    <div className='banner'>
        <div className='banner_content'>
            <h1>Follow the status of your favorite game servers in real time!</h1>
            <p>Welcome to MagicBot's server monitoring platform.
                <br />
                See at a glance the server status of Guns of Glory, Misty Continent and Stormshot servers.
                <br />
                You'll know in real time whether servers are online, under maintenance or down.
            </p>
        </div>
        <img className='desktop_banner' src={DesktopBanner} alt='desktop' />

    </div>
);

export default Banner;
